import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Menu from "@material-ui/core/Menu";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";

export const StyledMenu = withStyles({
  paper: {},
})((props) => (
  <Menu
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

export const StyledDrawer = withStyles((theme) => ({
  root: {
    position: "relative !important",
  },
  paperAnchorLeft: {
    width: "80%",
    height: "100vh", //'auto'
    [theme.breakpoints.up("sm")]: {
      width: "50%",
    },
  },
}))((props) => <Drawer {...props} />);

export const StyledButton = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    opacity: 0.2,
    color: theme.palette.primary.main,
  },
}))((props) => <Button {...props} />);
